/**
 * Route for `bulk-select-bulk-actions`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { BulkSelectBulkActionsPage } from "../features/bulk-select-bulk-actions/BulkSelectBulkActionsPage";

export const bulkSelectBulkActionsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/bulk-select-bulk-actions",
	component: BulkSelectBulkActionsPage,
});

export default bulkSelectBulkActionsRoute;
